import { useCallback } from "react";
import { LicensesApi, useAPIAction } from "melco-shared-logic";
import { CancelLicenseActionButtonInterface } from "../../components/licenses/CancelLicenseButton";
import { getUTCObjectFromLocalDate } from "../../helper/dateHelper";

export const useCancelLicense = () => {
  const [cancelLicense] = useAPIAction(
    LicensesApi,
    async (api, cancelActionDetails: CancelLicenseActionButtonInterface) => {
      const data = await api.cancelSerialNumber({
        serialNumber: cancelActionDetails.licenseSerialNumberToCancel,

        controlcenterMelcoModelsCancelSerialNumber: {
          comments: cancelActionDetails.CancellationReason,
          sub_cancelled_date: cancelActionDetails.subCancelledDate
            ? getUTCObjectFromLocalDate(cancelActionDetails.subCancelledDate)
              .utcStartOfDay
            : undefined,
        },
      });

      return {
        successMessages: [{ message: "default" }],
        data,
      };
    },
    {
      translationPrefix: "licenses.basic.detail.cancel",
    }
  );

  return useCallback(
    async (cancelActionDetails: CancelLicenseActionButtonInterface) => {
      try {
        await cancelLicense(cancelActionDetails);
      } catch (e) {
        // error handling is already done in useAPIAction
        console.log(e);
      }

      return cancelActionDetails.licenseSerialNumberToCancel;
    },
    [cancelLicense]
  );
};
